var React = require('react');

function L1 (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"L1"),React.createElement("g",{"style":{"isolation":"isolate"},"key":1},React.createElement("polygon",{"points":"50.47 79.65 48.5 58.81 29.07 60.65 29.07 60.65 23.34 0 0 2.21 7.7 83.69 50.47 79.65","fill":"#f47643","style":{"mixBlendMode":"multiply"}}))]);
}

L1.defaultProps = {"viewBox":"0 0 50.47 83.69"};

module.exports = L1;

L1.default = L1;
